import React from "react";

// components
import Request from "../misc/Request";
import Training from "../misc/Training";
// import PieChart from "../../../component/ui/charts/PieChart";
// import BarChart from "../../../component/ui/charts/BarChart";

// state
import { useAppDispatch } from "../../../store";
import { getAuthUser } from "../../../services/apis/auth";
import TotalCountCard from "../misc/TotalCountCard";
import { useAnalytics } from "../../../hooks/useAnalytics";

const DashBoard = () => {
  const dispatch = useAppDispatch();
  const {
    trainingCounts,
    loadTraining,
    serviceCounts,
    loadService,
    requestCounts,
    loadRequest,
    loadOpportunity,
    opportunityCounts,
    loadCompany,
    companyCounts,
    loadUser,
    userCounts,
  } = useAnalytics();

  const onLoad = React.useCallback(async () => {
    getAuthUser(dispatch);
  }, [dispatch]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  return (
    <div className="pb-12">
      <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-4">
        <TotalCountCard
          title="Service"
          total={serviceCounts.total_service}
          activeCount={requestCounts}
          loading={loadService}
          subtitleLoading={loadRequest}
          countText="Requests"
        />

        <TotalCountCard
          title="Training"
          total={trainingCounts.total_training}
          activeCount={trainingCounts.total_active_training}
          loading={loadTraining}
          subtitleLoading={loadTraining}
        />

        <TotalCountCard
          title="Opportunity"
          total={opportunityCounts.total_opportunity}
          activeCount={opportunityCounts.total_active_opportunity}
          loading={loadOpportunity}
        />

        <TotalCountCard
          title="Company"
          total={companyCounts.total_company}
          activeCount={userCounts.total_user}
          loading={loadCompany}
          subtitleLoading={loadUser}
          countText="Users"
        />
      </div>

      {/* <div className="w-full flex flex-col lg:flex-row items-center p-4 bg-white rounded-xl shadow-md mt-4">
        <div className="w-full lg:w-[65%] h-[40vh] border p-2 mr-2">
          <BarChart />
        </div>
        <div className="w-full lg:w-[35%] h-[40vh] p-2">
          <PieChart />
        </div>
      </div> */}

      <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
        <Request />
        <Training />
      </div>
    </div>
  );
};

export default DashBoard;
